import { ValidatorFn, FormGroup, ValidationErrors } from '@angular/forms';

export const hasOneUppercaseValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const valid = control.value.match(/[A-Z]/g);
  return (valid ? null : {'hasOneUppercase': true});
};
